module.exports = __webpack_public_path__ + "static/media/openMsgActive.50c69372.svg";